var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgHpmsLinkWeb = function SvgHpmsLinkWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#000",
    width: 25,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#000",
    cx: 3,
    cy: 3,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#000",
    cx: 7,
    cy: 3,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#000",
    cx: 11,
    cy: 3,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    d: "M1 5.5h23"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "CentraleSans-Bold, Centrale Sans",
    fontSize: 8,
    fontWeight: "bold",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2.708,
    y: 15
  }, "www")))));
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjdweCIgaGVpZ2h0PSIyMnB4IiB2aWV3Qm94PSIwIDAgMjcgMjIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDY0ICg5MzUzNykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+SWNvbjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQuMDAwMDAwLCAtNy4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9Ikljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUuMDAwMDAwLCA4LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgc3Ryb2tlPSIjMDAwMDAwIiB4PSIwIiB5PSIwIiB3aWR0aD0iMjUiIGhlaWdodD0iMjAiIHJ4PSIyIj48L3JlY3Q+CiAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBzdHJva2U9IiMwMDAwMDAiIGN4PSIzIiBjeT0iMyIgcj0iMSI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsLUNvcHkiIHN0cm9rZT0iIzAwMDAwMCIgY3g9IjciIGN5PSIzIiByPSIxIj48L2NpcmNsZT4KICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwtQ29weS0yIiBzdHJva2U9IiMwMDAwMDAiIGN4PSIxMSIgY3k9IjMiIHI9IjEiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgPGxpbmUgeDE9IjEiIHkxPSI1LjUiIHgyPSIyNCIgeTI9IjUuNSIgaWQ9IkxpbmUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSI+PC9saW5lPgogICAgICAgICAgICAgICAgPHRleHQgaWQ9Ind3dyIgZm9udC1mYW1pbHk9IkNlbnRyYWxlU2Fucy1Cb2xkLCBDZW50cmFsZSBTYW5zIiBmb250LXNpemU9IjgiIGZvbnQtd2VpZ2h0PSJib2xkIiBmaWxsPSIjMDAwMDAwIj4KICAgICAgICAgICAgICAgICAgICA8dHNwYW4geD0iMi43MDgiIHk9IjE1Ij53d3c8L3RzcGFuPgogICAgICAgICAgICAgICAgPC90ZXh0PgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgHpmsLinkWeb as ReactComponent };